<template>
  <div>
    <van-popup v-model:show="showPopup" position="bottom">
      <div class="deposito-popup">
        <div class="deposito-popup-header">
          <div class="chxy-row-bt header-view">
            <div class="header-left" @click="onClickLeft">
              <van-icon name="arrow-left" class="arrow-icon" />
            </div>
            <div class="header-center">Depósito</div>
            <div class="header-right">
              <div class="support-message">
                <div class="support-container mr-20px" @click="toMessage()">
                  <img :src="getImageUrlWithCDN_TEST('/deposito/dep-one.png')" class="dep-one" />
                </div>
                <div class="support-container mr-5px" @click="handleDepositoRecordPopupOpen()">
                  <img :src="getImageUrlWithCDN_TEST('/deposito/dep-two.png')" class="dep-one" />
                </div>
              </div>
            </div>
          </div>
          <div class="pagamento-container">
            <div class="pagamento">Método de Pagamento</div>
            <div class="chxy-row-bt money-view">
              <div>
                <img :src="getImageUrlWithCDN_TEST('/home/pt.png', 'local')" class="pt-icon" />
              </div>
              <span class="money">
                {{ isRefreshing ? 'loading' : formatNumberWithComma(balance) || '0.00' }}
              </span>
              <div>
                <img
                  :src="getImageUrlWithCDN_TEST('/profile/refresh.png')"
                  class="refresh-icon"
                  :class="{ rotating: isRefreshing }"
                  @click="handleRefresh"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="fix-h"></div>
        <div class="h-24px"></div>

        <van-tabs v-model:active="tabsActive" shrink line-width="100" @click-tab="handleTabClick">
          <van-tab>
            <template #title>
              <div class="tabs-title-slot">
                <div class="icon-box">
                  <img class="icon" :src="getImageUrlWithCDN_TEST('/deposito/phone-online.png')" />
                </div>
                <span class="title">Depósito online</span>
              </div>
            </template>
            <div class="phone-online-container">
              <div class="group-view-container">
                <div class="grupo-view">
                  <img
                    class="grupo-img"
                    :src="getImageUrlWithCDN_TEST('/profile/pix-logo.png', 'local')"
                  />
                  <span class="grupo-text">{{ DepositoGroupType }}</span>
                </div>
                <div class="grupo-view">
                  <img
                    class="grupo-img"
                    :src="getImageUrlWithCDN_TEST('/profile/pix-logo.png', 'local')"
                  />
                  <span class="grupo-text">{{ DepositoGroupType }}</span>
                </div>
              </div>
              <div class="line1"></div>
              <div class="chxy-row-ac flex-fw">
                <div class="but-item-check">PIX</div>
              </div>

              <div class="line2"></div>
              <div class="h-10"></div>
              <div class="deposito">Depósito</div>
              <div v-if="hadFirstDeposito" class="dep-group-container">
                <div v-for="(item, index) in rechargeChannel.quick_amounts" :key="index">
                  <div
                    class="chxy-column-c-c"
                    :class="checkMoneyIndex == index ? 'dep-item-check' : 'dep-item'"
                    @click="checkMoney(index, item)"
                  >
                    <div class="dep-t">{{ formatNumberWithThousandsSeparator(item || 0) }}</div>
                    <div class="chxy-row-c-c dep-b">
                      +{{ formatNumberWithComma(rechargeChannel?.quick_reward[index] || 0) }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="dep-group-container">
                <div v-for="(item, index) in rechargeChannel.quick_amounts" :key="index">
                  <div
                    class="chxy-column-c-c"
                    :class="checkMoneyIndex == index ? 'dep-item-check' : 'dep-item'"
                    @click="checkMoney(index, item)"
                  >
                    <div class="dep-t2">{{ formatNumberWithThousandsSeparator(item || 0) }}</div>
                  </div>
                </div>
              </div>
              <div class="h-10"></div>
              <div>
                <!-- Mínimo10~Máximo50.000  v-if="!moneyBonusFlag"-->
                <van-field
                  v-model="moneyValue"
                  class="field-border-radius"
                  :class="{
                    error: inputMoneyType == 'error',
                    success: inputMoneyType == 'success',
                  }"
                  label="R$"
                  :placeholder="
                    'Mínimo' + rechargeChannel.min_amount + '~Máximo' + rechargeChannel.max_amount
                  "
                  :clearable="true"
                  @blur="blurFun"
                  @clear="clearFun"
                  @update:model-value="handleUpdateFun"
                />

                <!-- 功能暂注释 -->
                <!-- <van-field
                  v-if="moneyBonusFlag"
                  v-model="moneyValue"
                  class="field-border-b"
                  label="R$"
                  :placeholder="
                    'Mínimo' + rechargeChannel.min_amount + '~Máximo' + rechargeChannel.max_amount
                  "
                  :clearable="true"
                  @blur="blurFun"
                  @clear="clearFun"
                />
                <div v-if="moneyBonusFlag" class="field-border-t">
                  <span>Você receberá</span>
                  <span class="t-all">126,00</span>
                  <span class="t-coletar">(Lembre-se de coletar)</span>
                  <span>，Bônus do evento</span>
                  <span class="t-add">+</span>
                  <span class="t-add">3,00</span>
                </div> -->
              </div>
              <div class="h-10"></div>
            </div>
          </van-tab>
          <van-tab>
            <template #title>
              <div class="tabs-title-slot">
                <div class="icon-box">
                  <img class="icon" :src="getImageUrlWithCDN_TEST('/deposito/criptomoeda.png')" />
                </div>
                <span class="title">Criptomoeda</span>
              </div>
            </template>
            <div class="criptomoeda-container">
              <div class="deposito-type">
                <div
                  v-for="e in usdtTypeList"
                  :key="e.id"
                  :class="['but-item-check tag', { checked: usdtTypeChecked.id === e.id }]"
                >
                  <img
                    class="type-icon"
                    :src="getImageUrlWithCDN_TEST(`/deposito/${e.icon}.png`, 'local')"
                  />
                  <span class="text">{{ e.name }}</span>
                </div>
              </div>

              <div class="deposito">
                {{
                  criptomoedaTypeCurrent.type === criptomoedaTypeEnum.USDT
                    ? 'Depósito'
                    : 'Valor do depósito'
                }}
              </div>
              <div class="field-type-container criptomoeda">
                <van-field
                  v-model="moneyValue"
                  :class="['field-border-radius', { flag: moneyBonusFlag }]"
                  :label="criptomoedaTypeCurrent.label"
                  :placeholder="
                    'Mínimo' +
                    criptomoedaTypeCurrent.min_amount +
                    '~' +
                    'Máximo' +
                    criptomoedaTypeCurrent.max_amount
                  "
                  :clearable="true"
                  @blur="blurFun"
                  @clear="clearFun"
                />
                <div
                  class="switch-icon-box chxy-row-c-c"
                  @click="handleCriptomoedaTypeCurrentSwitch"
                >
                  <img class="icon" :src="getImageUrlWithCDN_TEST('/deposito/exchange.png')" />
                </div>
              </div>
              <div class="ratio-valor-container chxy-colunm-ac">
                <p class="title">Taxa de Câmbio</p>
                <div class="value-container chxy-row-bt">
                  <div class="ratio-box chxy-row-ac">
                    <span class="value">1 : 5,5703617165</span>
                    <img :src="getImageUrlWithCDN_TEST('/activity/jz.png')" class="refresh-icon" />
                  </div>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>

        <!-- 存款优惠活动 -->
        <div v-if="hadFirstDeposito">
          <div class="deposit-container">
            <div class="h-10"></div>
            <div class="chxy-row-bt">
              <div class="chxy-row-ac">
                <img :src="getImageUrlWithCDN_TEST('/deposito/Oferta.png')" class="gife-icon" />
                <span class="oferta">Oferta de Depósito</span>
              </div>
              <div class="chxy-row-ac lt-view">
                <div class="lt-icon-container">
                  <img :src="getImageUrlWithCDN_TEST('/deposito/lt.png')" class="lt-icon" />
                  <span class="lt-text">LT</span>
                </div>
                <van-count-down ref="countDown" millisecond :time="downTime" format="HH:mm:ss:S" />
              </div>
            </div>
            <div class="deposit-desc">
              ----- Participou automaticamente das seguintes atividades-----
            </div>
            <div v-for="(item, index) in rechargeChannel.quick_amounts" :key="index">
              <div v-if="index < moreShow" class="primeiro chxy-row-bt">
                <div class="chxy-row-ac">
                  <div class="primeiro-1"></div>
                  <img
                    class="primeiro-2-img"
                    :src="getImageUrlWithCDN_TEST('/deposito/Bonus.png')"
                  />
                  <span class="primeiro-3-text">Bônus</span>
                  <span class="primeiro-4-text">
                    {{ formatNumberWithComma(rechargeChannel?.quick_reward[index] || 0) }}
                  </span>
                </div>
                <div class="chxy-row-ac primeiro-5-text">
                  <span class="label">Primeiro depósito≥</span>
                  <span class="value">{{ formatNumberWithThousandsSeparator(item || 0) }}</span>
                  <img
                    v-if="isCurrentLevel(item, index)"
                    class="primeiro-6-img"
                    :src="getImageUrlWithCDN_TEST('/deposito/gou.png')"
                  />
                  <div v-else class="primeiro-6-img" />
                </div>
              </div>
            </div>
          </div>
          <!-- 更多收缩 -->
          <div class="chxy-row-c-c expand-container" @click="handleMoreChange">
            <div class="expand-text">{{ moneyListMore ? 'Passar' : 'Expandir' }}</div>
            <van-icon v-show="!moneyListMore" name="arrow-down" class="expand-icon" />
            <van-icon v-show="moneyListMore" name="arrow-up" class="expand-icon" />
          </div>
        </div>
        <div class="deposit-now-button" @click="toDepositeDebounce">Deposite agora</div>
      </div>

      <DepositoPay ref="depositoPayRef" :pay-info="payInfo" @close="handleDepositoPayClose" />
    </van-popup>

    <DepositoRecordPopup ref="DepositoRecordPopupRef" />

    <van-loading v-if="isLoading" vertical class="loading-overlay"></van-loading>
  </div>
</template>

<script setup>
import { debounce } from '@/utils/debounce'
import { userBalanceApi } from '@/api/deposito'
import { languageColumns, locale } from '@/utils/i18n'
import { STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { rechargeIndex, rechargeStartApi } from '@/api/deposito'
import { useEventBus } from '@vueuse/core'
import { formatNumberWithComma, formatNumberWithThousandsSeparator } from '@/utils/format.js'
const balanceEventBus = useEventBus('refresh-balance')

const router = useRouter()
const { t } = useI18n()
const downTime = ref('')
const countDown = ref(null)
const isLoading = ref(false)
const balance = ref(false)

const GameGroupType = computed(() => {
  return JSON.parse(localStorage.getItem('localConfig')).gameGroupType || ''
})
const DepositoGroupType = computed(() => {
  switch (GameGroupType.value) {
    case 'A1':
      return 'GRUPO A1-PIX'
    case 'WE':
      return 'GRUPO WE-PIX'
    case 'VOY':
      return 'BRL-PIX'
    case '91':
      return 'GRUPO 91-PIX'
    case 'W1':
      return 'GRUPO W1-PIX'
    case 'A8':
      return 'GRUPO A8-PIX'
    case 'DZ':
      return 'GRUPO DZ-PIX'
    default:
      return 'GRUPO AE-PIX'
  }
})

const tabsActive = ref(0)
const isRefreshing = ref(false) // 刷新状态
const moneyValue = ref() // 充值金额
const moneyBonus = ref() // 奖金
const moneyBonusAll = ref() // 总值（充值金额 + 奖金）
const moneyBonusFlag = ref(false) // 金币赠送活动  标志
const hadFirstDeposito = ref(false) // 金币赠送活动 首充值是否有
const moneyListMore = ref(false) // 金币赠送list 开关
const moreShow = ref(3)
const checkMoneyIndex = ref(-1)

const usdtTypeList = ref([{ id: 1, name: 'TRC20-USDT', value: '', icon: 'usdt-icon' }])
const usdtTypeChecked = reactive({
  id: 1,
  name: 'TRC20-USDT',
  value: '',
})

//
const DepositoRecordPopupRef = ref(null)
const handleDepositoRecordPopupOpen = () => {
  nextTick(() => {
    DepositoRecordPopupRef.value.open()
  })
}

const handleUsdtTypeChange = (e) => {
  for (const key in usdtTypeChecked) {
    usdtTypeChecked[key] = e[key]
  }
}

const handleTabClick = (e) => {
  // if (tabsActive.value === 1) {
  //   showToast('')
  // }
}

/**
 * 充值类型为 Criptomoeda 货币时
 */
const criptomoedaLabelEnum = reactive({
  USDT: 'U',
  Dollar: 'R$',
})
const criptomoedaTypeEnum = reactive({
  USDT: 'USDT',
  Dollar: 'Dollar',
})
const criptomoedaTypeList = reactive([
  {
    label: criptomoedaLabelEnum.USDT,
    min_amount: '5',
    max_amount: '1.000.000',
    type: criptomoedaTypeEnum.USDT,
  },
  {
    label: criptomoedaLabelEnum.Dollar,
    min_amount: '28',
    max_amount: '5.570.361',
    type: criptomoedaTypeEnum.Dollar,
  },
])
const criptomoedaTypeCurrent = reactive({
  label: 'U',
  min_amount: '5',
  max_amount: '1.000.000',
  type: 'USDT',
})
const handleCriptomoedaTypeCurrentSwitch = () => {
  const list = toRaw(criptomoedaTypeList)
  switch (criptomoedaTypeCurrent.type) {
    case criptomoedaTypeEnum.USDT:
      handleCriptomoedaTypeCurrentChange(criptomoedaTypeList[1])
      break
    case criptomoedaTypeEnum.Dollar:
      handleCriptomoedaTypeCurrentChange(criptomoedaTypeList[0])
      break
  }
}
const handleCriptomoedaTypeCurrentChange = (object) => {
  for (const key in criptomoedaTypeCurrent) {
    criptomoedaTypeCurrent[key] = object[key]
  }
}

const payInfo = ref({})

const toMessage = () => {
  showPopup.value = false
  router.push({
    name: 'Messages',
    query: {
      type: 1,
    },
  })
}

const toRegistros = () => {
  showPopup.value = false
  router.push({
    name: 'Registros',
    query: {
      type: 1,
    },
  })
}

const checkMoney = (index, item) => {
  checkMoneyIndex.value = index
  moneyValue.value = item
  currentLevelIndex.value = index
}
// 处理刷新点击事件
const handleRefresh = async () => {
  if (isRefreshing.value) return // 如果正在刷新，则不处理重复点击

  const { data } = await userBalanceApi()
  balance.value = data.balance

  isRefreshing.value = true

  // 模拟刷新过程，1秒后结束
  setTimeout(() => {
    isRefreshing.value = false
  }, 1000)
}

const handleDepositoPayClose = () => {
  handleRefresh()
}

const handleMoreChange = () => {
  moneyListMore.value = !moneyListMore.value
  moreShow.value = moneyListMore.value ? 99 : 3
}

const clearFun = (even) => {
  console.log('even:', even)
}
const inputMoneyType = ref('')
watch(moneyValue, (val) => {
  const min = Number(rechargeChannel.value.min_amount)
  const max = Number(rechargeChannel.value.max_amount)
  if (val == '' || Number(val) < min || Number(val) > max) {
    inputMoneyType.value = 'error'
  } else {
    inputMoneyType.value = 'success'
  }
})
// 输入框失去焦点 触发接口 充值预览api/transfer/rechargePreview（最新版本不需要）
const blurFun = (even) => {
  console.log('blurFun even:', even)
  // if (moneyValue.value > 0) {
  //   // 调用接口 查询赠送的金额 再赋值给 moneyBonus
  //   moneyBonusFlag.value = true
  //   moneyBonusAll.value = 99
  //   moneyBonus.value = 50
  //   checkMoneyIndex.value = 999
  // } else {
  //   moneyBonusAll.value = 0
  //   moneyBonus.value = 0
  //   moneyBonusFlag.value = false
  // }
}

// 当前匹配的档位索引
const currentLevelIndex = ref(-1)

// 监听输入框输入事件
const handleUpdateFun = (newVal) => {
  // 重置选中状态
  checkMoneyIndex.value = -1
  // 重置当前档位索引
  currentLevelIndex.value = -1

  if (
    newVal > 0 &&
    rechargeChannel.value.has_activity == 1 &&
    rechargeChannel.value.quick_reward?.length > 0 &&
    rechargeChannel.value.quick_amounts?.length > 0
  ) {
    let applicableBonus = 0
    let maxApplicableAmount = 0
    let matchedIndex = -1

    // 找到小于等于输入金额的最大档位
    for (let i = 0; i < rechargeChannel.value.quick_amounts.length; i++) {
      const amount = Number(rechargeChannel.value.quick_amounts[i])
      if (newVal >= amount && amount > maxApplicableAmount) {
        maxApplicableAmount = amount
        applicableBonus = Number(rechargeChannel.value.quick_reward[i])
        matchedIndex = i
      }
    }

    // 更新当前档位索引
    currentLevelIndex.value = matchedIndex
    moneyBonus.value = applicableBonus
    moneyValue.value = newVal
    moneyBonusFlag.value = applicableBonus > 0
  } else {
    moneyBonusFlag.value = false
    moneyBonus.value = 0
  }
}

// 判断当前档位是否应该显示勾选图标
const isCurrentLevel = (item, index) => {
  return currentLevelIndex.value === index
}
const showPopup = ref(false)

// 定义emit事件
const emit = defineEmits(['refresh'])

const onClickLeft = () => {
  balanceEventBus.emit()
  showPopup.value = false
}

const depositoPayRef = ref()
const showPopupPay = ref(false)

const toDeposite = async () => {
  if (
    moneyValue.value >= +rechargeChannel.value.min_amount &&
    moneyValue.value <= +rechargeChannel.value.max_amount
  ) {
    isLoading.value = true
    const sendData = {
      amount: Number(moneyValue.value),
    }
    try {
      const { data, code } = await rechargeStartApi(sendData)
      if (code == 1) {
        payInfo.value = data
        depositoPayRef.value?.openPopupDepositPay()
        checkMoneyIndex.value = -1
        moneyValue.value = ''
      }
    } finally {
      isLoading.value = false
    }
  } else {
    showToast({
      message:
        'Insira o valor coreto, limite (' +
        rechargeChannel.value.min_amount +
        '~' +
        rechargeChannel.value.max_amount +
        ')',
      wordBreak: 'break-word',
    })
  }
}
const toDepositeDebounce = debounce(toDeposite, 1000, true)

const rechargeChannel = ref({})
const userInfo = ref({})
async function initData() {
  const { data } = await rechargeIndex()
  rechargeChannel.value = data.recharge_channel
  // rechargeChannel.value.quick_amounts 逗号拼接的string，转成数组
  rechargeChannel.value.quick_amounts = rechargeChannel.value.quick_amounts.split(',')
  rechargeChannel.value.quick_reward = rechargeChannel.value.quick_reward.split(',')
  userInfo.value = data.user_info
  hadFirstDeposito.value = data.recharge_channel.has_activity
  downTime.value = Number(rechargeChannel.value.countdown || 0) * 1000 // 30 * 60 * 60 * 1000
  if (countDown.value) {
    countDown.value.reset()
  }
}

// 提供给父组件调用的方法
const openPopupDeposit = () => {
  showPopup.value = true
  checkMoneyIndex.value = -1
  moneyValue.value = ''
  initData()
  handleRefresh()
}
// 暴露给父组件的方法和状态
defineExpose({
  openPopupDeposit,
})
</script>

<style lang="scss" scoped>
::v-deep(.van-overlay) {
  z-index: 1999 !important;
}
:deep(.van-tabs__nav) {
  background: transparent;
}
.deposito-popup {
  background-color: var(--deposito-view-bg);
  height: calc(100vh - 45px);
  height: calc(100dvh - 45px);
  width: 100vw;
  border-radius: 10px 10px 0 0;
  overflow-y: scroll;
  --van-field-label-width: 20px;
  :deep(.van-field) {
    height: 35px !important;
    --van-field-label-color: var(--deposito-card-title) !important;
  }
  .van-cell {
    padding: 5px 10px;
  }

  .deposito-popup-header {
    position: fixed;
    z-index: 1;
    .header-view {
      position: relative;
      width: 100vw;
      height: 46px;
      width: 100vw;
      border-radius: 10px 10px 0 0;
      background-color: var(--deposito-view-bg);

      .header-left {
        position: absolute;
        // margin-left: 10px;
        width: 40px;
        height: 50px;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .arrow-icon {
          color: var(--deposito-arrow-icon);
        }
      }
      .header-center {
        width: 100%;
        font-size: 16px;
        color: var(--deposito-card-title);
        text-align: center;
      }
      .header-right {
        position: absolute;
        top: 0;
        right: 0;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        .support-message {
          display: flex;
          padding: 10px;
          .dep-one {
            width: 16px;
            height: 18px;
          }

          .dep-two {
            width: 17px;
            height: 18px;
          }
        }
      }
    }
  }
}

.tabs-title-slot {
  position: relative;
  display: flex;
  align-items: center;

  .icon-box {
    margin-right: 6px;
    width: 16px;
    height: 16px;

    .icon {
      width: 100%;
      height: 100%;
    }
  }
  .title {
    height: 16px;
  }
  .interest-rate-tag {
    position: absolute;
    right: 2px;
    top: -10px;
  }
}

.deposito-type {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  padding: 15px 0 10px;
  margin-bottom: 10px;
  border-top: 1px solid var(--deposito-card-border-bottom);
  border-bottom: 1px solid var(--deposito-card-border-bottom);

  .but-item-check {
    position: relative;
    padding: 7px 2.5px 0;
    border-radius: 5px;
    border: 1px solid var(--deposito-tag-border);
    min-width: 0;
    max-width: 100%;
    height: fit-content;
    text-align: center;
    &.checked {
      border-color: var(--deposito-tag-active-border);
      .text {
        color: var(--deposito-tag-active-text);
      }
    }
    &.tag {
      .interest-rate-tag {
        position: absolute;
        right: -10px;
        top: -8px;
      }
    }

    .type-icon {
      display: inline-block;
      width: 27px;
      height: 27px;
    }
    .text {
      display: inline-block;
      width: 100%;
      // margin-top: 4px;
      font-size: 13px;
      color: var(--deposito-tag-text);
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.field-type-container {
  &.criptomoeda {
    display: grid;
    grid-template-columns: auto 36px;
    grid-gap: 10px;
    margin-top: 10px;

    .switch-icon-box {
      width: 36px;
      height: 36px;
      border: 1px solid var(--deposito-card-border);
      border-radius: 8px;

      .icon {
        width: 18px;
        height: 18px;
      }
    }
  }
}

.fix-h {
  height: 66px;
}
.m10 {
  margin: 0 10px;
}

.phone-online-container {
  padding-top: 15px;
  margin: 0 10px;
  border-top: 1px solid var(--deposito-card-border-bottom);

  .but-item-check {
    width: 112px;
    height: 38px;
    margin-top: 10px;
    border-radius: 4px;
    border: 1px solid var(--deposito-tag-border);
    line-height: 38px;
    text-align: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 12px;
    color: var(--deposito-tag-text);
  }
}

.criptomoeda-container {
  padding: 0 10px 10px;

  .ratio-valor-container {
    padding: 5px 0 0;
    line-height: 1;

    .title {
      font-size: 12px;
      color: var(--deposito-card-label);
    }
    .value-container {
      font-size: 12px;
      color: var(--deposito-card-value);

      .ratio-box {
        .value {
          margin-right: 6px;
        }
        .refresh-icon {
          width: 11px;
          height: 11px;
        }
      }

      .valor-box {
        font-weight: 700;
        color: var(--deposito-card-value__highlight);
      }
    }
  }
}

.group-view-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  .grupo-view {
    border-radius: 5px;
    border: 1px solid var(--deposito-tag-border);
    min-width: 0;
    max-width: 100%;
    padding: 7px 2.5px 0px;
    text-align: center;
    .grupo-img {
      display: inline-block;
      width: 27px;
      height: 27px;
    }
    .grupo-text {
      display: inline-block;
      width: 100%;
      font-size: 13px;
      color: var(--deposito-tag-text);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.field-border-radius {
  border-radius: 7px;
  :deep(.van-field__label) {
    width: fit-content;
    font-size: 12px;
  }
  :deep(.van-field__control) {
    &::placeholder {
      font-size: 11px;
    }
  }
  &.error {
    border: 1px solid #ff0000 !important;
  }
  &.success {
    border: 1px solid #00da0f !important;
  }
}
.field-border-b {
  border-radius: 7px 7px 0 0;
  border: 1px solid var(--deposito-card-border-bottom);
}
.field-border-t {
  padding: 7px 10px;
  border-radius: 0 0 7px 7px;
  background-color: #f5eceb;
  border-bottom: 1px solid #f0bab5;
  border-left: 1px solid #f0bab5;
  border-right: 1px solid #f0bab5;
  height: 44px;
  line-height: 15px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 11px;
  color: #000000;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .t-all {
    font-weight: 600;
    margin-left: 2px;
  }
  .t-coletar {
    color: #04be02;
  }
  .t-add {
    color: #ffaa09;
  }
}
.deposit-container {
  width: 356px;
  min-height: 100px;
  background: var(--special-deposito-bonus-bg);
  border-radius: 10px 10px 10px 10px;
  border: 1px solid var(--special-deposito-bonus-border);
  margin: 0 10px;
  .gife-icon {
    width: 13px;
    height: 13px;
    margin-right: 5px;
    margin-left: 22px;
  }

  .oferta {
    font-family: Roboto, Roboto;
    font-weight: 600;
    font-size: 12px;
    color: var(--special-deposito-bonus-header-label);
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .deposit-desc {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 10px;
    color: var(--special-deposito-bonus-header-value);
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 10px 0;
  }

  .lt-view {
    position: relative;
    // border: 1px solid red;
    height: 14px;
    margin-right: 5px;
    padding-right: 3px;
    --van-count-down-font-size: 10px;
    --van-count-down-text-color: var(--special-deposito-bonus-header-tag-text);
    border: 1px solid var(--van-count-down-text-color);
    .lt-icon-container {
      position: relative;
      margin-left: -10px;

      .lt-icon {
        width: 22px;
        height: 14px;
        margin-right: 2px;
      }
      .lt-text {
        position: absolute;
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
        color: white;
        font-size: 9px;
      }
    }
  }

  .primeiro {
    width: 344px;
    height: 32px;
    background: var(--special-deposito-bonus-list-item-bg);
    border-radius: 5px 5px 5px 5px;
    margin: 0 6px;
    margin-bottom: 5px;

    .primeiro-1 {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      background-color: var(--special-deposito-bonus-list-border);
      height: 32px;
      width: 5px;
    }
    .primeiro-2-img {
      width: 22px;
      height: 22px;
      margin-left: 10px;
    }

    .primeiro-3-text {
      width: 28px;
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 10px;
      color: var(--special-deposito-bonus-list-left-label);
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 8px;
    }
    .primeiro-4-text {
      font-family: Roboto, Roboto;
      font-weight: 500;
      font-size: 10px;
      color: var(--special-deposito-bonus-list-left-value);
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-left: 5px;
    }
    .primeiro-5-text {
      height: 10px;
      font-family: Roboto, Roboto;
      font-weight: 400;
      font-size: 10px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .label {
        color: var(--special-deposito-bonus-list-right-label);
      }
      .value {
        color: var(--special-deposito-bonus-list-right-value);
      }
    }
    .primeiro-6-img {
      width: 10px;
      height: 8px;
      margin: 0 5px;
    }
  }
}

.expand-container {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.expand-text {
  margin-right: 5px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: var(--special-deposito-bonus-footer-more-text);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.expand-icon {
  margin-top: 2px;
  font-size: 12px;
  color: var(--special-deposito-bonus-footer-arrow-icon);
}

.deposit-now-button {
  margin: 15px 10px;
  width: 354px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  background: var(--deposito-card-button-bg);
  border-radius: 5px;
  font-size: 12px;
  color: var(--deposito-card-button-text);
}

.money-view {
  min-width: 70px;
  height: 20px;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid var(--special-deposito-balance-border);

  .money {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 12px;
    color: var(--special-deposito-balance-text);
    text-align: center;
    font-style: normal;
    text-decoration-line: underline;
    text-underline-offset: 2px;
    text-transform: none;
  }
}

.refresh-icon {
  width: 15px;
  height: 15px;
  margin-right: 2px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.refresh-icon.rotating {
  animation: rotateThreeTimes 1s linear forwards;
}

@keyframes rotateThreeTimes {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1080deg); /* 3圈 = 3 * 360度 */
  }
}

.pagamento-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  background-color: var(--deposito-view-bg);
  z-index: 99;
}

.pagamento {
  font-family: Roboto, Roboto;
  font-weight: bold;
  font-size: 12px;
  color: var(--deposito-card-title);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.support-icon {
  width: 17px;
  height: 15px;
  margin-right: 8px;
}
.message-icon {
  width: 15px;
  height: 15px;
}
.line1 {
  width: 355px;
  height: 1px;
  background: var(--deposito-card-border-bottom);
  margin-top: 10px;
}
.line2 {
  width: 355px;
  height: 1px;
  background: var(--deposito-card-border-bottom);
  margin-top: 10px;
}

.deposito {
  font-family: Roboto, Roboto;
  font-weight: bold;
  font-size: 12px;
  color: var(--deposito-card-title);
  text-align: left;
  font-style: normal;
  text-transform: none;
}

.dep-item-check {
  width: 81px;
  height: 40px;
  background: var(--deposito-amount-item-bg);
  border-radius: 4px;
  border: 1px solid var(--deposito-amount-item-active-border);

  .dep-t {
    height: 22px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-value);
  }
  .dep-t2 {
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-value);
  }
  .dep-b {
    height: 17px;
    background-color: rgba(255, 170, 9, 0.1);
    width: 100%;
    border-radius: 0 0 4px 4px;
    color: var(--deposito-amount-item-value__highlight);
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
  }
}

.dep-group-container {
  display: grid;
  grid-template-columns: repeat(4, calc(100% / 4 - 3 * 10px / 4));
  grid-gap: 10px;
  margin-top: 10px;
}
.dep-item {
  width: 100%;
  height: 40px;
  background: var(--deposito-amount-item-bg);
  border-radius: 4px;
  border: 1px solid transparent;

  .dep-t {
    height: 22px;
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-value);
  }
  .dep-t2 {
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
    color: var(--deposito-amount-item-value);
  }
  .dep-b {
    height: 17px;
    background-color: rgba(255, 170, 9, 0.1);
    width: 100%;
    border-radius: 0 0 4px 4px;
    color: var(--deposito-amount-item-value__highlight);
    font-family: Roboto, Roboto;
    font-weight: 500;
    font-size: 12px;
  }
}
.lembrete {
  width: 355px;
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 12px;
  color: var(--deposito-card-value);
  text-align: left;
  font-style: normal;
  text-transform: none;
  line-height: 15px;
}
.pt-icon {
  width: 17px;
  height: 17px;
  margin-left: 1px;
}

// 此处可以全局样式 省的重复
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  z-index: 9990;
  overflow: hidden;
}
</style>
